exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "p.error-msg {\n    position: absolute;\n    top: 45px;\n    right: 0;\n    padding: 10px;\n    border: 1px solid #ddd;\n    background: #fdcbcb;\n    border-radius: 20px;\n    margin: 0;\n    font-size: 10px;\n    color: #f00;\n}\n\n.head {\n    padding: 16px 20px;\n    margin-bottom: 0;\n    background-color: #f7f7f9;\n    font-size: 18px;\n    font-weight: 400;\n    line-height: 22px;\n    cursor: pointer;\n}\n.poll-data {\n    border: 1px solid rgba(0,0,0,.125);\n    padding: 15px;\n    margin-top: 20px;\n    clear: both;\n}\n.poll-data label {\n\tmargin:0;\n}\n.sponsors-type input[type=\"text\"] {\n    width: calc(100% - 70px);\n}\n.priority-type input[type=\"text\"] {\n    width: calc(100% - 120px);\n}\n.right-arrow {\n    float: right;\n    padding-top: 9px;\n}\n.priority-type {\n    margin-bottom: 10px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/event/sponsors-form/sponsors-form.component.css
// module id = ../../../../../src/app/event/sponsors-form/sponsors-form.component.css
// module chunks = main